import { EntityType } from '@frontend/common';
import { DocumentClient } from '@frontend/document/api';
import { useLocale } from '@frontend/lang';
import { SettingClient } from '@frontend/setting/api';
import { SettingKey } from '@frontend/setting/types';
import { useEffect, useState } from 'react';

import { useAppSelector } from '../../redux/store';

const DEFAULT_PRIVACY_POLICY = 'https://telloport.com/privacy-policy/';

interface ViewProps {
    privacyLoading: boolean;
    accountPrivacyDocument?: string;
}

const useReadPrivacyPolicy = (): ViewProps => {
    const { locale } = useLocale();
    const navigationState = useAppSelector((store) => store.navigation);
    const accountId = navigationState.iot?.account_id;
    const [privacyLoading, setPrivacyLoading] = useState<boolean>(true);
    const [accountPrivacyDocument, setAccountPrivacyDocument] = useState<string>(DEFAULT_PRIVACY_POLICY);

    useEffect(() => {
        if (accountId) {
            SettingClient.fetchSettings({ entity_type: EntityType.ACCOUNT, entity_id: accountId })
                .then((settingsResult) => {
                    const privacyDocSetting = settingsResult.results.find((s) => s.key === SettingKey.PRIVACY_POLICY_DOCUMENT_ID);
                    if (privacyDocSetting && privacyDocSetting.value && typeof privacyDocSetting.value === 'string') {
                        DocumentClient.fetchDocumentSasUrl(accountId, privacyDocSetting.value, locale)
                            .then(setAccountPrivacyDocument)
                            .catch(() => setPrivacyLoading(false));
                    } else setPrivacyLoading(false);
                })
                .catch(() => setPrivacyLoading(false));
        }
    }, [accountId]);

    return { privacyLoading, accountPrivacyDocument };
};

export default useReadPrivacyPolicy;
